<template>
  <div class="app-container">
    <!-- Schermi stretti: il menu aperto sta SOPRA la pagina, e toccando fuori
         si richiude. Ridotto a icone resta invece accanto alla pagina. -->
    <div
      v-if="store.isLogged == true && narrow && !isCollapse"
      class="sidebar-backdrop"
      aria-hidden="true"
      @click="isCollapse = true"
    />
    <el-container class="layout-container">
      <!-- MODERN SIDEBAR -->
      <el-aside
        v-if="store.isLogged == true"
        :width="isCollapse ? '64px' : '260px'"
        class="modern-sidebar"
        :class="{ 'is-collapsed': isCollapse, 'is-drawer': narrow && !isCollapse }"
      >
        <!-- Brand Header -->
        <div class="sidebar-header">
          <div class="brand-container">
            <el-icon
              :size="28"
              class="brand-icon"
            >
              <Briefcase />
            </el-icon>
            <transition name="fade">
              <span
                v-show="!isCollapse"
                class="brand-name"
              >
                Gestionale Simba
              </span>
            </transition>
          </div>
          <el-button
            :icon="isCollapse ? 'Expand' : 'Fold'"
            circle
            size="small"
            class="collapse-btn"
            @click="handleButtonClick"
          />
        </div>

        <!-- Navigation Menu -->
        <el-scrollbar class="sidebar-scrollbar">
          <el-menu
            :collapse="isCollapse"
            :collapse-transition="false"
            :default-active="activeMenu"
            class="sidebar-menu"
            router
          >
            <!-- Booking Section -->
            <el-sub-menu index="1">
              <template #title>
                <el-icon><Calendar /></el-icon>
                <span>Booking</span>
              </template>
              <el-menu-item-group>
                <!-- Province con almeno un partner: la lista legge ?provincia= dall'indirizzo. -->
                <el-menu-item
                  index="/booking"
                  :route="{ path: '/booking' }"
                >
                  <el-icon><Grid /></el-icon>
                  <span>Tutte le province</span>
                </el-menu-item>
                <el-menu-item
                  v-for="p in provinces"
                  :key="p.id"
                  :index="`/booking?provincia=${p.id}`"
                  :route="{ path: '/booking', query: { provincia: p.id } }"
                >
                  <el-icon><Location /></el-icon>
                  <span>{{ p.name }}</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-sub-menu>

            <!-- Driver -->
            <router-link
              class="routerLink"
              to="/driver"
            >
              <el-menu-item index="/driver">
                <el-icon><Van /></el-icon>
                <template #title>
                  Driver
                </template>
              </el-menu-item>
            </router-link>

            <!-- Capacità driver per provincia -->
            <router-link
              class="routerLink"
              to="/driver/capacity"
            >
              <el-menu-item index="/driver/capacity">
                <el-icon><Odometer /></el-icon>
                <template #title>
                  Capacità driver
                </template>
              </el-menu-item>
            </router-link>

            <!-- Clienti -->
            <router-link
              class="routerLink"
              to="/customer"
            >
              <el-menu-item index="/customer">
                <el-icon><User /></el-icon>
                <template #title>
                  Clienti
                </template>
              </el-menu-item>
            </router-link>

            <!-- Partner -->
            <router-link
              class="routerLink"
              to="/partner"
            >
              <el-menu-item index="/partner">
                <el-icon><OfficeBuilding /></el-icon>
                <template #title>
                  Partner
                </template>
              </el-menu-item>
            </router-link>

            <!-- Agenzie -->
            <router-link
              class="routerLink"
              to="/agency"
            >
              <el-menu-item index="/agency">
                <el-icon><School /></el-icon>
                <template #title>
                  Agenzie
                </template>
              </el-menu-item>
            </router-link>

            <!-- Fornitori: chi ci noleggia i mezzi per i Transfer. È una
                 risorsa Simba (costi interni), quindi il backend la riserva
                 ai ruoli globali. -->
            <router-link
              class="routerLink"
              to="/supplier"
            >
              <el-menu-item index="/supplier">
                <el-icon><Van /></el-icon>
                <template #title>
                  Fornitori
                </template>
              </el-menu-item>
            </router-link>

            <!-- Advisor: chi segue i partner per conto di Simba (COD7).
                 Risorsa Simba, riservata ai ruoli globali. -->
            <router-link
              class="routerLink"
              to="/advisor"
            >
              <el-menu-item index="/advisor">
                <el-icon><Avatar /></el-icon>
                <template #title>
                  Advisor
                </template>
              </el-menu-item>
            </router-link>

            <!-- Contabilità -->
            <router-link
              class="routerLink"
              to="/contabilita"
            >
              <el-menu-item index="/contabilita">
                <el-icon><SuitcaseLine /></el-icon>
                <template #title>
                  Contabilità
                </template>
              </el-menu-item>
            </router-link>

            <!-- Divider -->
            <div class="menu-divider" />

            <!-- Logout -->
            <el-menu-item
              index="logout"
              class="logout-item"
              @click="logout"
            >
              <el-icon><SwitchButton /></el-icon>
              <span>Logout</span>
            </el-menu-item>
          </el-menu>
        </el-scrollbar>
      </el-aside>

      <!-- MAIN CONTENT AREA -->
      <el-container class="main-container">
        <!-- TOP HEADER -->
        <el-header
          v-if="store.isLogged == true"
          height="64px"
          class="modern-header"
        >
          <div class="header-left">
            <h2 class="page-title">
              {{ getPageTitle() }}
            </h2>
          </div>
          <div class="header-right">
            <el-button
              circle
              size="default"
            >
              <el-icon><Bell /></el-icon>
            </el-button>
            <div class="user-info">
              <el-avatar
                :size="36"
                class="user-avatar"
              >
                <el-icon><UserFilled /></el-icon>
              </el-avatar>
              <div
                v-if="store.employee"
                class="user-details"
              >
                <span class="user-name">{{ store.employee.name }} {{ store.employee.surname }}</span>
                <span class="user-role">{{ store.role || 'Admin' }}</span>
              </div>
            </div>
          </div>
        </el-header>

        <!-- PAGE CONTENT -->
        <el-main class="modern-main">
          <transition
            name="fade-slide"
            mode="out-in"
          >
            <router-view />
          </transition>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { useRouter, useRoute } from 'vue-router';
import { ref, computed, watch, onBeforeUnmount } from 'vue';
import { isLoggedStore } from './store/logged';
import areasAPI from './services/areasAPI.js';
export default {
  name: 'App',
  setup() {
    const store = isLoggedStore();
    const router = useRouter();
    const route = useRoute();

    const logout = () => {
      // Svuota tutta la sessione persistita (token, scadenze, identità).
      store.viewMenu = false;
      store.isLogged = false;
      store.role = '';
      store.accessToken = '';
      store.refreshToken = '';
      store.refreshExp = '';
      store.jwtExp = '';
      store.id = '';
      store.mail = '';
      store.employee = {};
      router.push('/login');
    };

    // Schermi stretti. Fino a 768 px il menu era `position: fixed`
    // anche ridotto a icone: usciva dall'impaginazione e copriva il bordo
    // sinistro di ogni pagina, e partiva pure aperto (260 px). Ora parte
    // ridotto e resta accanto alla pagina; aperto diventa un pannello sopra
    // la pagina, che si richiude toccando fuori o cambiando pagina.
    const query = window.matchMedia('(max-width: 768px)');
    const narrow = ref(query.matches);
    let isCollapse = ref(narrow.value);
    const onNarrowChange = (e) => {
      narrow.value = e.matches;
      if (e.matches) isCollapse.value = true;
    };
    query.addEventListener('change', onNarrowChange);
    onBeforeUnmount(() => query.removeEventListener('change', onNarrowChange));
    watch(
      () => route.fullPath,
      () => {
        if (narrow.value) isCollapse.value = true;
      }
    );

    const handleButtonClick = () => {
      isCollapse.value = !isCollapse.value;
    };

    const provinces = ref([]);
    const loadProvinces = async () => {
      try {
        provinces.value = await areasAPI.getPartnerProvinces({ force: true });
      } catch (e) {
        console.error('Caricamento province fallito', e);
      }
    };
    // Le province del menu servono solo da loggati: si caricano all'avvio se
    // c'è già una sessione e a ogni login.
    watch(
      () => store.isLogged,
      (logged) => {
        if (logged) loadProvinces();
        else provinces.value = [];
      },
      { immediate: true }
    );

    // Sulla lista filtrata va evidenziata la provincia, non «Tutte».
    const activeMenu = computed(() =>
      route.path === '/booking' && route.query.provincia
        ? `/booking?provincia=${route.query.provincia}`
        : route.path
    );

    const getPageTitle = () => {
      const titles = {
        '/booking': 'Gestione Booking',
        '/driver': 'Gestione Driver',
        '/driver/capacity': 'Capacità driver',
        '/customer': 'Gestione Clienti',
        '/partner': 'Gestione Partner',
        '/agency': 'Gestione Agenzie',
        '/supplier': 'Fornitori mezzi',
        '/advisor': 'Advisor',
        '/journey/new': 'Nuovo percorso',
        '/contabilita': 'Contabilità',
        '/estimate': 'Calcola Preventivo',
      };
      return titles[route.path] || 'Dashboard';
    };

    return {
      logout,
      store,
      narrow,
      isCollapse,
      handleButtonClick,
      provinces,
      activeMenu,
      getPageTitle,
    };
  },

};
</script>

<style scoped>
/* ==================== APP CONTAINER ==================== */
.app-container {
  width: 100%;
  min-height: 100vh;
  background: #f8fafc;
}

.layout-container {
  min-height: 100vh;
}

/* ==================== MODERN SIDEBAR ==================== */
.modern-sidebar {
  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);
  border-right: 1px solid #334155;
  box-shadow: 4px 0 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 100;
}

.sidebar-header {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border-bottom: 1px solid #334155;
  background: rgba(30, 41, 59, 0.5);
}

.brand-container {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}

.brand-icon {
  color: #818cf8;
  font-weight: bold;
}

.brand-name {
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: -0.02em;
}

.collapse-btn {
  background: rgba(99, 102, 241, 0.1);
  border: 1px solid rgba(99, 102, 241, 0.2);
  color: #818cf8;
  transition: all 0.2s ease;
}

.collapse-btn:hover {
  background: rgba(99, 102, 241, 0.2);
  border-color: #6366f1;
  color: #a5b4fc;
  transform: scale(1.05);
}

.sidebar-scrollbar {
  height: calc(100vh - 64px);
}

.sidebar-menu {
  border-right: none;
  background: transparent;
  padding: 12px 0;
}

.menu-divider {
  height: 1px;
  background: #334155;
  margin: 12px 16px;
}

.logout-item {
  margin: 8px 12px;
  border-radius: 8px;
  color: #f87171 !important;
}

.logout-item:hover {
  background: rgba(248, 113, 113, 0.1) !important;
}

/* ==================== MAIN CONTAINER ==================== */
.main-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #f8fafc;
}

/* ==================== MODERN HEADER ==================== */
.modern-header {
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  z-index: 99;
}

.header-left {
  display: flex;
  align-items: center;
}

.page-title {
  font-size: 20px;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.02em;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
  cursor: pointer;
}

.user-info:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.user-avatar {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
}

.user-details {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.2;
}

.user-name {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}

.user-role {
  font-size: 12px;
  color: #64748b;
  text-transform: capitalize;
}

/* ==================== MAIN CONTENT ==================== */
.modern-main {
  background: #f8fafc;
  padding: 24px;
  overflow-y: auto;
}

/* ==================== ROUTER LINK ==================== */
.routerLink {
  text-decoration: none;
}

/* ==================== TRANSITIONS ==================== */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-slide-enter-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-slide-leave-active {
  transition: all 0.2s cubic-bezier(0.4, 0, 1, 1);
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(10px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* Ridotto a icone la barra è larga 64 px: marchio e pulsante affiancati non
   ci stanno, resta solo il pulsante. */
.modern-sidebar.is-collapsed .sidebar-header {
  padding: 0;
  justify-content: center;
}
.modern-sidebar.is-collapsed .brand-container {
  display: none;
}

/* ==================== RESPONSIVE ==================== */
.sidebar-backdrop {
  position: fixed;
  inset: 0;
  z-index: 999;
  background: rgba(15, 23, 42, 0.45);
}

@media (max-width: 768px) {
  /* Aperto su schermo stretto: pannello sopra la pagina. Ridotto a icone
     resta nel flusso, accanto alla pagina, e non la copre più. */
  .modern-sidebar.is-drawer {
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    z-index: 1000;
  }

  .modern-header {
    padding: 0 16px;
  }

  .page-title {
    font-size: 18px;
  }

  .user-details {
    display: none;
  }

  .modern-main {
    padding: 16px;
  }
}
</style>

<style>
/* ==================== GLOBAL OVERRIDES FOR APP ==================== */
#app {
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  background: #f8fafc;
}

.max-height {
  min-height: 100vh;
  height: 100%;
}
</style>
